// This is a very primitive platform detection, but it's good enough for now.
// We only use it to produce a platform-specific keyboard shortcut hint.

export function platform() {
  if ('userAgentData' in window.navigator) {
    return window.navigator.userAgentData.platform;
  }

  if (window.navigator.platform.indexOf('Mac') !== -1) {
    return 'macOS';
  }

  return 'Windows';
}
